import React, { useState } from "react";
import { Table, Pagination } from "antd";
import "antd/dist/antd.css";
import "../css/antd_table_custom-1.0.1.css";

const DataTable = (props) => {
  
DataTable.defaultProps = { placeholder: "Search..."}

  function listItemClick(e) {

    var index = e.currentTarget.id.charAt(0);
    if (props.onSelect === undefined || props.onSelect === null) {

    } else {
      props.onSelect(props.dataSource[index]);
    }
  }

  function tableRowClick(e) {

    if (props.onSelect === undefined || props.onSelect === null) {

    } else {
      props.onSelect(e);
    }
  }

  //---------------------------------------------------
  // search function
  // use for search result
  const [data, setData] = useState(loadData);
  function loadData(){
    if(localStorage.getItem("filterString") !== null){
      let searchResult = [];
      searchResult = filterIt(props.dataSource, localStorage.getItem("filterString") );
      return searchResult;
    } else {  
    	return props.dataSource;
    }
  }
  
  
  // load filter string if any
  const [filterString, setFilterString] = useState(loadFilterString);
  function loadFilterString(){
    if(localStorage.getItem("filterString") !== null){
      //setFilterString(localStorage.getItem("filterString"));
      return localStorage.getItem("filterString");
    } else {
      //setFilterString("");
      return "";
    }
  }
  // update data in table display
  function update(e) {
	
    let searchResult = [];
//    let str = trimString(e.currentTarget.value);
    let str = e.currentTarget.value;
    setFilterString(str);
    searchResult = filterIt(props.dataSource, str);
    setData(searchResult);
    localStorage.setItem("filterString", str);
  }

  // remove space
  function trimString(s) {
    var l = 0,
      r = s.length - 1;
    while (l < s.length && s[l] === " ") l++;
    while (r > l && s[r] === " ") r -= 1;
    return s.substring(l, r + 1).toLowerCase();
  }


//function filterIt(arr, searchKey) { 
//
//    return arr.filter(function (obj) {
//      return Object.keys(obj).some(function (key) {
//        if (obj[key] === undefined || obj[key] === null) {          
//          return false;
//        } else {          
//          return obj[key].toString().toLowerCase().includes(searchKey);
//        }
//      });
//    });
//  }


function filterIt(arr, searchKey) { 

	let tableCols = [];
	if (props.columns) {
		props.columns.forEach(function (columnInfo) {
	    	tableCols.push(columnInfo.dataIndex);
		});
	}

    return arr.filter(function (obj) {
      return Object.keys(obj).some(function (key) {
        if (obj[key] === undefined || obj[key] === null) {          
          return false;
        } else {          
			if (tableCols.includes(key)) {
	          	return obj[key].toString().toLowerCase().includes(searchKey.toLowerCase());
      		} else {
            	return false;
          } 
      		
        }
      });
    });
  }

  // end search functions
  //---------------------------------------------------

  //--------------------------------------------------------
  // export table as csv
  // Grab the data passed in to component and convert it to CSV then download
  function download_data_as_csv(separator = ",") {


	var json = data;
	var fields = Object.keys(json[0]);
	var replacer = function(key, value) { return value === null ? '' : value }; 
	var csv = json.map(function(row){
	  return fields.map(function(fieldName){
	    return JSON.stringify(row[fieldName], replacer);
	  }).join(',');
	})
	csv.unshift(fields.join(',')) // add header column
	let csv_string = csv.join('\r\n');
//	 console.log("Downloaded data", csv_string);
//	console.log(csv_string)


    // Create FILENAME and Download it 
    //TODO: filename should not be hardcoded.
    var filename =
      "Monthly_Call_Log_Report_" + new Date().toLocaleDateString() + ".csv";
    var link = document.createElement("a");
    link.style.display = "none";
    link.setAttribute("target", "_blank");
    link.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv_string)
    );
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  // end export to csv function
  //---------------------------------------------------------



  //---------------------------------------------------------

  // three value use for display list
  // sory by
  // current page #
  // list of items per page
  const [sortBy, setSortBy] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentCount, setCurrentCount] = useState(10);
  // use for list view
  const [datal, setDatal] = useState(build_list_view_data);
  const [datalp, setDatalp] = useState(data.length);

  //on page load, list first 10 item
  function build_list_view_data() {
    var list_data = [];
    list_data = (props.dataSource).map((a) => ({ ...a }));
    
    if(localStorage.getItem("filterString") !== null){
       let searchResult = [];
      searchResult = filterIt(list_data, localStorage.getItem("filterString") );
      return searchResult.slice(0, 9);
    }
    else {
	    return list_data.slice(0, 9);
	  }
  }

  // sort list, table already have sort
  const [data_sdp, setData_sdp] = useState(build_data_sdp);
  // build sort list dropdown, with asc and dec
  function build_data_sdp() {
    var data = [];
    var emptyValue = {};
    emptyValue.title = "Sort by";
    emptyValue.value = "";
    data.push(emptyValue);
    for (var i = 0; i < props.columns.length; i++) {
      var temp = Object.assign({}, props.columns[i]);
      temp.title = temp.title + " asc";
      temp.value = temp.dataIndex + " asc";
      var temp2 = Object.assign({}, props.columns[i]);
      temp2.title = temp2.title + " dec";
      temp2.value = temp2.dataIndex + " dec";
      data.push(temp);
      data.push(temp2);
    }

    return data;
  }

  // sort data
  // handle click on dropdown change
  // load page # and size from statehook
  function sortList(selectedSortBy) {
    if (selectedSortBy === undefined || selectedSortBy === null) {
      selectedSortBy = "";
    }

    setSortBy(selectedSortBy);
    var dataNew = [];
    dataNew = data.map((a) => ({ ...a }));

    // have sory by info,
    if (selectedSortBy.length > 3) {
      var key = selectedSortBy.split(" ");
      if (key[1] !== "dec") {
        dataNew.sort((a, b) => (a[key[0]] > b[key[0]] ? 1 : -1));
      } else {
        dataNew.reverse((a, b) => (a[key[0]] > b[key[0]] ? 1 : -1));
      }
    }


    var start = currentPage * currentCount - currentCount;
    if (start < 0) {
      start = 0;
    }
    var end = currentPage * currentCount;

    setDatal(dataNew.slice(start, end));
  }

  // sort data
  function sortList2(selectedSortBy, page, size) {
    if (selectedSortBy === undefined || selectedSortBy === null) {
      selectedSortBy = "";
    }

    setSortBy(selectedSortBy);
    var dataNew = [];
    dataNew = data.map((a) => ({ ...a }));

    // have sory by info,
    if (selectedSortBy.length > 3) {
      var key = selectedSortBy.split(" ");
      if (key[1] !== "dec") {
        dataNew.sort((a, b) => (a[key[0]] > b[key[0]] ? 1 : -1));
      } else {
        dataNew.reverse((a, b) => (a[key[0]] > b[key[0]] ? 1 : -1));
      }
    }


    var start = page * size - size;
    if (start < 0) {
      start = 0;
    }
    var end = page * size;
    setDatal(dataNew.slice(start, end));
  }

  // end sort
  //---------------------------------------------------------

  //-----------------------------------------------------------
  // handle click on Pagination buttons, per page change
  // calling sortList2, passing page # and size
  function onShowSizeChange(page, size) {

    setCurrentPage(page);
    setCurrentCount(size);
    sortList2(sortBy, page, size);
  }

  // handle list search string update
  function updatel(e) {

    var dataNew = [];
    let str = trimString(e.currentTarget.value);
    dataNew = filterIt(props.dataSource, str);
    setFilterString(str);        
    localStorage.setItem("filterString", str);
    
    
    //setData(searchResult);
    if (sortBy.length > 3) {
      var key = sortBy.split(" ");
      if (key[1] !== "dec") {
        dataNew.sort((a, b) => (a[key[0]] > b[key[0]] ? 1 : -1));
      } else {
        dataNew.reverse((a, b) => (a[key[0]] > b[key[0]] ? 1 : -1));
      }
    }

    // setup list view with search result
    setDatal(dataNew.slice(0, currentCount));
    // setup Pagination total
    setDatalp(dataNew.length);
  }

  let i = 0;
  let j = 0;
  let k = 0;

  const [header, setHeader] = useState(
    props.columns.filter(function (el) {
      return el.dataIndex !== "link";
    })
  );
  
  if (true == false) {
    setHeader();
    setData_sdp();
  };
  
  return (
    <div className="checkbox__item">
      {/* <label className="inputbox__label">{props.label}</label> */}
      {/* table desktop view */}
      <div className="ant-table-wrapper-desktop">
        <input
          className="table-search-input"
          id="sq"
          placeholder={props.placeholder}
          onChange={update}
          style={props.searchEnable ? {} : { display: "none" }}
          value={filterString}
        />
        <div
          href="#"
          className={`export-CSV-Link ${
            props.exportCSV ? "" : "inputbox__required--hide"
          }`}
          onClick={download_data_as_csv}
        />
        <Table
          dataSource={data}
          columns={props.columns}
          id={props.id}
          onRow={(r) => ({
            onClick: () => tableRowClick(r)
          })}
          pagination={{
            pageSizeOptions: ["5", "10", "25", "50", "100"],
            showSizeChanger: true
          }}
          loading={{ indicator: <div><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>, spinning:props.loading}}
        />
      </div>
      {/* table list mobile view  */}
      <div className="ant-table-wrapper-mobile">
        <input
          className="table-search-input"
          id="sql"
          placeholder={props.placeholder}
          onChange={updatel}
          style={props.searchEnable ? {} : { display: "none" }}
          value={filterString}
        />
        <select
          className="table-sort-dropdown"
          name="sort_list_dropdown"
          id="sort_list_dropdown"
          onChange={(e) => sortList(e.target.value)}
          style={props.mobileViewSortEnable ? {} : { display: "none" }}
        >
          {data_sdp.map((item) => (
            <option className="dropdown__item" value={item.value} key={i++}>
              {item.label !== undefined ? item.label : item.title}
            </option>
          ))}
        </select>
        <i
          class="arrow"
          style={props.mobileViewSortEnable ? {} : { display: "none" }}
        ></i>
        <div
          href="#"
          className={`export-CSV-Link ${
            props.exportCSV ? "" : "inputbox__required--hide"
          }`}
          onClick={download_data_as_csv}
        />
        {datal.map((item, index) => (
          <div key={k++} className="list_item--div" id={"item_" + k}>
            <div
              id={j++ + "_item"}
              onClick={listItemClick}
              className="list_item--datas"
            >
              {header.map((column, index) => (
                <div>
                  <span className="list_item--title">{column.title}: </span>
                  <span className="list_item--txt">
                    {item[column.dataIndex]}
                  </span>
                </div>
              ))}
            </div>
            <div className="list_item--link"></div>
          </div>
        ))}
        <Pagination
          showSizeChanger
          onChange={onShowSizeChange}
          defaultCurrent={1}
          total={datalp}
          pageSizeOptions={["5", "10", "25", "50", "100"]}
        />
      </div>
    </div>
  );
};

export default DataTable;
